import "./ConocenosSection.css";
import NavigationButton from "../Button/NavigationButton";

export default function ConocenosSection() {
    return (
        <section className="conocenos-section" id="ConocenosSection">
            <div className="text-box">
                <div className="container">
                    <p className="texto">
                        Mana Petita, empresa de ideación, planificación y coordinación de todo tipo de eventos. Creamos
                        experiencias y recuerdos, siempre haciendo un poco más bonita la experiencia de cada pareja, de cada cliente.
                    </p>
                </div>
                <NavigationButton titulo={"Mostrar más"} path={"#NuestrosServiciosSection"} />
            </div>
        </section>
    );
}
